/**
 ** This file is for storing Tanstack Query
 */
export const CourseKey = {
  ResultsList: 'courseResultList',
  SectionList: 'courseSectionList',
  SubsectionList: 'courseSubsectionList',
  UnitList: 'courseUnitList',
  ActivityList: 'courseActivityList',
}

export const ClassKey = {
  ExamList: 'classExamList',
  ExamInfo: 'examInfo',
}

export const UserKey = {
  ExamList: 'userExamList',
}

export const TeacherKey = {
  MyClass: 'myClass',
  ScheduleRequest: 'teacherScheduleRequest',
}

export const StudentKey = {
  Student: 'student',
  StudentsTestResult: 'studentsTestResult',
  ChapterTest: 'chapterTest',
}

export const ProgressKey = {
  ProgressList: 'progressList',
  ProgressDetail: 'progressDetail',
}
